import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumberFromString, CountryCode } from 'libphonenumber-js';

@Pipe({ name: 'phoneFormat' })
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string, country: CountryCode = 'US'): string {
    if (!value) return '';
    try {
      const phone = parsePhoneNumberFromString(value, { defaultCountry: country });
      return phone ? phone.formatNational() : value;
    } catch {
      return value;
    }
  }
}
